import { on } from "delegated-events";
import SlimSelect from "slim-select";
import "slim-select/styles";
import ajax from "@common/ajax";
import { generateQueryString } from "@common/util";

const form = document.querySelector(".filter-form");

let multiSelects = [];
let isClearing = false;

const setupMultiSelect = (el) => {
  const select = new SlimSelect({
    select: el,
    settings: {
      allowDeselect: true,
      closeOnSelect: false,
      showSearch: false,
      maxValuesShown: 1,
      maxValuesMessage: "{number} selected",
    },
    events: {
      afterChange: (val) => {
        if (!isClearing) {
          if (val.length === 0) {
            el.value = "";
          }

          handleFilterChange();
        }
      },
    },
  });

  multiSelects.push(select);
};

const handleFilterChange = (e) => {
  e && e.preventDefault();

  const params = new FormData(form);

  multiSelects.forEach((el) => {
    params.delete(el.selectEl.name);

    const name = el.selectEl.name.replace("[]", "");
    const value = el.getSelected().join("_");

    if (value) {
      params.append(name, value);
    }
  });

  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}` : form.action;

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = () => {
  form.querySelectorAll('input[type="search"]').forEach((x) => (x.value = null));

  multiSelects.forEach((select) => {
    isClearing = true;
    select.setSelected([]);
  });

  window.history.replaceState({}, "", form.action);

  updateResults();

  isClearing = false;
};

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    form.classList.add("is-filtered");
  } else {
    form.classList.remove("is-filtered");
  }
};

const init = () => {
  if (form) {
    form.querySelectorAll("select[multiple]").forEach((el) => setupMultiSelect(el));

    on("submit", ".filter-form", handleFilterChange);
    on("click", ".filter-form-clear", handleFilterClear);
  }
};

init();
